export default __webpack_public_path__ + "static/media/KNOWN_HOW.5d7fdb74.pdf";